import { UI, Stack } from '@genial/components';
import { BoxRadius, Spacing, Typography } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

import {
  TableContent,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../../../../../components/TableContent';
import { useGlobalAssetContext } from '../../../../../contexts';
import { useFixedIncomeSellAssetController } from '../../../../../hooks/products/FixedIncomeSell';
import { LateralBar } from '../../../components/LateralBar';
import { fixedIncomeSellConstants } from '../constants';
import { ListLoadingItemDesktop } from '../ListLoadingItem/desktop';

import { FixedIncomeListItemTypes } from '.';

export const FixedIncomeListItemDesktop: React.FC<FixedIncomeListItemTypes.Props> = ({ offer }) => {
  const id = offer.productIdNormalized;
  const {
    amountItem,
    handleChangeAmountItem,
    errorMessage,
    hasError,
    netFinancialValue,
    netFinancialValueFormatted,
  } = useFixedIncomeSellAssetController(offer);

  const { infoGetter, selectedTab } = useGlobalAssetContext();

  const completeOffer = { ...offer, orderQuantity: amountItem || 0, orderValue: netFinancialValue };

  const { Button, isSelected, forceLoading } = infoGetter(
    'fixedIncomeSell',
    completeOffer,
    'productIdNormalized'
  );

  const getFlex = (index: number) => {
    const currentHead = fixedIncomeSellConstants.tableHead.find((_, i) => i === index);
    return currentHead?.flex || 1;
  };

  if (forceLoading) {
    return <ListLoadingItemDesktop />;
  }

  return (
    <TableContent
      direction="row"
      space={0}
      p={0}
      px={Spacing['inline.xxxs']}
      h="80px"
      isHighlighted={isSelected}>
      <LateralBar
        backgroundColor={selectedTab.color}
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <TableContentItemColumn flex={getFlex(0)}>
        <TableContentItemText>{offer.issuerFullName}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(1)}>
        <TableContentItemText>{offer.availableQuantityNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(2)}>
        <TableContentItemText>{offer.irFormatted}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(3)}>
        <TableContentItemText>{netFinancialValueFormatted}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(4)}>
        <Stack pr={Spacing['inline.xxxs']}>
          <UI.InputStepper
            stepperValue={1}
            max={offer.availableAmount}
            min={1}
            name={`fixed-income-amount-order-input-${id}`}
            keyboardType="numeric"
            fontSize={Typography['fontsize.md']}
            defaultValue={amountItem || 0}
            onChange={handleChangeAmountItem}
            showErrorMessage={false}
            {...(hasError && {
              customError: errorMessage,
              showErrorMessage: true,
            })}
          />
        </Stack>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(5)}>
        <TableContentItemText>{offer.availableInAccountNormalized}</TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(6)}>
        <Box w={'100%'}>
          <Button
            id={selectedTab.typeGetterId}
            isDisabled={hasError}
            offer={completeOffer}
            productContextConstant={selectedTab}
          />
        </Box>
      </TableContentItemColumn>
    </TableContent>
  );
};
